<template>
  <el-container class="file-doc" direction="vertical">
    <el-row style="width: 100%; height: 49px;">
      <el-menu class="horizontal-menu" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
               unique-opened background-color="rgba(0, 0, 0, 0)" text-color="rgba(1, 1, 1, 1)">
        <el-menu-item class="horizontal-menu-item" :index="3">网关</el-menu-item>
        <el-menu-item class="horizontal-menu-item" :index="4">感知器</el-menu-item>
      </el-menu>
      <el-row style="height: 1px;width: 100%;background-color: #FFF" />
    </el-row>
    <common-panel style="height: calc(100% - 49px);" :panel-data="selPanel" :key="activeIndex"/>
  </el-container>
</template>

<script>
import {Message} from 'element-ui';
import CommonPanel from "../../common/panel/CommonPanel";
export default {
  name: "DeviceManage",
  components: {CommonPanel},
  created() {
    this.selPanel = this.commitPanel;
  },
  data() {
    return{
      activeIndex: 3,
      selPanel: null,
      // 通信单元
      commitPanel: {
        hasTree: true,
        hasTreeToolbar: false,
        treeProps: {
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.manageCenter.getBuildTree,
        noneIcon: 'zy-icon-commit',
        queryMethod: this.$api.manageCenter.getGatewayInfo,
        filterForm: [
          {label: '运行状态：', prop: 'status', type: 'select', value: -1, style: 'width: 146px;margin-left: 8px;',
            props: {value: 'value', label: 'label'},
            options: [{value: -1, label: '全部'}, {value: 1, label: '在线'}, {value: 0, label: '离线'}]
          },
          {label: '名称：', prop: 'gatName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '同步', icon: 'zy-icon-refresh-two', type: 'function', handleIndex: -1, text: true, method: this.$api.manageCenter.refreshGateway},
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true}
        ],
        methods: {
          query_prop: 'id',
          query_id: 'id',
          edit: this.$api.manageCenter.updateGatewayInfo
        },
        tableCheck: true,
        tableTitle: '集中器列表',
        tableProps: [
          {prop: "gatName", label: "网关名称"},
          {prop: "gatAddr", label: "网关地址"},
          {prop: "status", label: "状态"},
          {prop: "proName", label: "网关协议"},
          {prop: "typeName", label: "网关类型"},
          {prop: "buildName", label: "所属建筑"},
          {prop: "installAddr", label: "安装地址"}
        ],
        dialogs: {
          add_edit: {
            title: '网关信息',
            width: '700px',
            editFlag: false,
            items: [
              {type: 'input', prop: 'gatAddr', label: '网关地址：', placeholder: '请输入网关地址', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'gatName', label: '网关名称：', placeholder: '请输入网关名称', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'proName', label: '通信协议：', placeholder: '选择', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'typeName', label: '网关类型：', placeholder: '请输入网关类型', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'gatIp', label: '网关IP：', placeholder: '请输入网关ip', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'status', label: '状态：', placeholder: '请输入服务器id', style: 'width: 205px;', editable: true},
              {type: 'select', prop: 'buildId', label: '所属建筑：', placeholder: '选择所属建筑', style: 'width: 205px;',
                method: this.$api.manageCenter.getBuildList,
                props: {value: 'id', label: 'buildName'},
                options: []
              },
              {type: 'input', prop: 'installAddr', label: '安装地址：', placeholder: '请输入安装地址', style: 'width: 205px;'}
            ],
            confirmMethod: null
          }
        }
      },
      // 感知器
      sensorPanel: {
        hasTree: true,
        hasTreeToolbar: false,
        treeProps: {
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.systemManage.getGatewayTree,
        noneIcon: 'zy-icon-sensor',
        queryMethod: this.$api.manageCenter.getSensorInfo,
        filterForm: [
          {label: '运行状态：', prop: 'status', type: 'select', value: -1, style: 'width: 146px;margin-left: 8px;',
            props: {value: 'value', label: 'label'},
            options: [{value: -1, label: '全部'}, {value: 1, label: '在线'}, {value: 0, label: '离线'}]
          },
          {label: '名称：', prop: 'sensorName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        buttons: [
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true}
        ],
        methods: {
          query_prop: 'id',
          query_id: 'id',
          edit: this.$api.manageCenter.updateSensorInfo
        },
        tableCheck: true,
        tableTitle: '感知器列表',
        tableProps: [
          {prop: "sensorName", label: "感知器名称"},
          {prop: "sensorAddr", label: "感知器地址"},
          {prop: "gatName", label: "所属网关"},
          {prop: "buildName", label: "测量建筑"},
          {prop: "proName", label: "通信协议"},
          {prop: "typeName", label: "感知器类型"},
          {prop: "status", label: "状态"},
          {prop: "sensorFac", label: "生产厂家"},
          {prop: "parentName", label: "父表"},
          {prop: "installAddr", label: "安装地址"}
        ],
        dialogs: {
          add_edit: {
            title: '感知器信息',
            width: '700px',
            editFlag: false,
            items: [
              {type: 'input', prop: 'sensorName', label: '感知器名称：', placeholder: '请输入感知器名', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'gatName', label: '网关：', placeholder: '选择通信单元', style: 'width: 205px', editable: true},
              {type: 'input', prop: 'sensorAddr', label: '通信地址：', placeholder: '请输入通信地址', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'typeName', label: '类型：', placeholder: '请选择能源分类', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'proName', label: '感知器协议：', placeholder: '选择感知器协议', style: 'width: 205px', editable: true},
              {type: 'select', prop: 'useId', label: '用途分类：', placeholder: '请选择用途分类', style: 'width: 205px;',
                method: this.$api.systemManage.getUseList,
                props: {value: 'id', label: 'useName'},
                options: []
              },
              {type: 'select', prop: 'buildId', label: '测量建筑：', placeholder: '请选择测量建筑', style: 'width: 205px;',
                method: this.$api.manageCenter.getBuildList,
                props: {value: 'id', label: 'buildName'},
                options: []
              },
              {type: 'input', prop: 'installAddr', label: '安装地址：', placeholder: '请输入安装地址', style: 'width: 205px;'},
              {type: 'input', prop: 'status', label: '状态：', placeholder: '请选择状态', style: 'width: 205px;', editable: true},
              {type: 'input', prop: 'sensorFac', label: '生产厂家：', placeholder: '请输入备注', style: 'width: 205px;', editable: true},
              {type: 'select', prop: 'parentId', label: '父表：', placeholder: '请输入备注', style: 'width: 205px;',
                method: this.$api.manageCenter.getSensorList,
                props: {value: 'id', label: 'sensorName'},
                options: []
              }
            ],
            confirmMethod: null
          }
        }
      }
    }
  },
  methods: {
    handleSelect(val) {
      this.activeIndex = val;
      switch (val) {
        case 3:
          this.selPanel = this.commitPanel;
          break;
        case 4:
          this.selPanel = this.sensorPanel;
          break;
        default:
          Message.warning('未知档案类型');
      }
    }
  }
}
</script>

<style scoped>
  .file-doc{
    width: 100%;
    height: 100%;
  }
  .horizontal-menu{
    border: 0;
    overflow-y: auto;
    height: 48px !important;
    line-height: 48px !important;
  }
  .horizontal-menu-item{
    border: 0;
    height: 48px !important;
    line-height: 48px !important;
    text-align: center;
    background-color: rgba(0, 0, 0, 0) !important;
  }
  .horizontal-menu-item:hover{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.2) !important;
  }
  .horizontal-menu-item.is-active{
    color: rgba(10, 82, 255, 1) !important;
    background: rgba(255, 255, 255, 0.8) !important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/DeviceManage.vue